import { useActivateMutation } from './useActivateMutation';
import { useSuspendMutation } from './useSuspendMutation';
import { useUnsuspendMutation } from './useUnsuspendMutation';
import { useTerminateMutation } from './useTerminateMutation';
import { SIM_PRODUCT_ACTION, SimProductAction } from '../constants/simProductActions';
import { useCancelLocationMutation } from './useCancelLocationMutation';
import { UseMutationOptions } from '@tanstack/react-query';

export const useMakeAction = (
  options?: Omit<UseMutationOptions<void, Error, { iccids: string[] }, unknown>, 'mutationFn'>,
) => {
  const { mutate: activateCards, isPending: activateCardsIsPending } = useActivateMutation(options);

  const { mutate: suspendCards, isPending: suspendCardsIsPending } = useSuspendMutation(options);

  const { mutate: unsuspendCards, isPending: unsuspendCardsIsPending } =
    useUnsuspendMutation(options);

  const { mutate: terminateCards, isPending: terminateCardsIsPending } =
    useTerminateMutation(options);

  const { mutate: cancelLocation, isPending: cancelLocationIsPending } =
    useCancelLocationMutation(options);

  const makeAction = (action: SimProductAction, params: { iccids: string[] }) => {
    if (action === SIM_PRODUCT_ACTION.ACTIVATE) activateCards(params);
    else if (action === SIM_PRODUCT_ACTION.SUSPEND) suspendCards(params);
    else if (action === SIM_PRODUCT_ACTION.UNSUSPEND) unsuspendCards(params);
    else if (action === SIM_PRODUCT_ACTION.TERMINATE) terminateCards(params);
    else if (action === SIM_PRODUCT_ACTION.CANCEL_LOCATION) cancelLocation(params);
  };
  return {
    makeAction,
    isPending:
      activateCardsIsPending ||
      terminateCardsIsPending ||
      cancelLocationIsPending ||
      suspendCardsIsPending ||
      unsuspendCardsIsPending,
  };
};
